import * as React from 'react';
import {Input} from "antd";
import IFieldOptions from "../../../../../../model/interface/form/elementOptions/IFieldOptions";
import {TextAreaProps} from "antd/lib/input/TextArea";

class FormFieldText {
    public static render = (options: IFieldOptions & TextAreaProps) => {
        const props = {
            style: options.style,
            placeholder: options.placeholder,
            allowClear: options.showClear,
            disabled: options.disabled,
            addonBefore: options.addonBefore,
            addonAfter: options.addonAfter,
            prefix: options.prefix,
            suffix: options.suffix,
            value: options.value,
            rows: options.textRows
        }

        return (
            <Input.TextArea autoSize={!options.textRows} {...props} />
        )
    }
}

export default FormFieldText